var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _circle, _path6, _path7, _g4, _rect, _rect2, _g5, _rect3, _rect4, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#FFDCC1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8837_22803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8837_22803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8639 12.9152C42.717 11.8452 45.0002 11.8453 46.8534 12.9152L72.7844 27.8864C74.6376 28.9564 75.7792 30.9337 75.7792 33.0735V63.0161C75.7792 65.1559 74.6376 67.1332 72.7844 68.2032L46.8534 83.1744C45.0002 84.2444 42.717 84.2444 40.8639 83.1744L14.9329 68.2032C13.0797 67.1332 11.9381 65.1559 11.9381 63.0161V33.0735C11.9381 30.9337 13.0797 28.9564 14.9329 27.8864L40.8639 12.9152Z",
    fill: "#FFB48B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3756 6.58582 9.86812L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#E06621"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8837_22803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42178C3.2998 5.11386 5.98141 2.43225 9.28934 2.43225H78.3993C81.7072 2.43225 84.3888 5.11386 84.3888 8.42178V49.9237C84.3888 52.2917 82.4692 54.2114 80.1012 54.2114C77.7332 54.2114 75.8136 56.131 75.8136 58.499V63.0137C75.8136 65.1549 74.6706 67.1331 72.8157 68.2026L46.838 83.1801C44.9853 84.2483 42.7037 84.2476 40.8517 83.1784L14.9121 68.2032C13.0588 67.1333 11.9171 65.1559 11.9171 63.016V58.52C11.9171 56.1404 9.98809 54.2114 7.60848 54.2114C5.22886 54.2114 3.2998 52.2823 3.2998 49.9027V8.42178Z",
    fill: "#FCCE2C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8837_22803)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0946 68.6001C35.9472 62.8527 20.2208 47.8338 20.2208 30.7053C20.2208 14.2211 34.4314 7.40009 44.0946 7.40009C53.7578 7.40009 67.7788 14.0317 67.7788 30.7053C67.7788 49.0737 52.1466 61.9616 44.4365 68.3181C44.3207 68.4136 44.2067 68.5076 44.0946 68.6001ZM44.3191 46.671C53.6847 46.671 61.277 39.0787 61.277 29.7131C61.277 20.3475 53.6847 12.7552 44.3191 12.7552C34.9535 12.7552 27.3612 20.3475 27.3612 29.7131C27.3612 39.0787 34.9535 46.671 44.3191 46.671Z",
    fill: "#C14F0E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8837_22803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 7,
    width: 48,
    height: 62
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2208 30.7053C20.2208 47.8338 35.9472 62.8527 44.0946 68.6001C51.6735 62.3475 67.7788 49.3496 67.7788 30.7053C67.7788 14.0317 53.7578 7.40009 44.0946 7.40009C34.4314 7.40009 20.2208 14.2211 20.2208 30.7053Z",
    fill: "#E06621"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8837_22803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5365 30.7053C14.5365 47.8337 30.2629 62.8527 38.4102 68.6C45.9892 62.3474 62.0945 49.3495 62.0945 30.7053C62.0945 14.0316 48.0734 7.40002 38.4102 7.40002C28.7471 7.40002 14.5365 14.2211 14.5365 30.7053Z",
    fill: "#FA823E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3191,
    cy: 31.4982,
    r: 16.9579,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9912 21.734C42.182 21.1685 42.7123 20.7878 43.3091 20.7878H45.3283C45.9251 20.7878 46.4554 21.1685 46.6462 21.734L52.3514 38.6383H36.286L41.9912 21.734Z",
    fill: "#FA823E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8837_22803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 20,
    width: 17,
    height: 19
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9912 21.734C42.182 21.1685 42.7123 20.7878 43.3091 20.7878H45.3283C45.9251 20.7878 46.4554 21.1685 46.6462 21.734L52.3514 38.6383H36.286L41.9912 21.734Z",
    fill: "#FA823E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8837_22803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3105 20.7878H44.3187L38.9636 38.6383H36.286L42.3105 20.7878Z",
    fill: "#C14F0E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.5009,
    y: 36.8524,
    width: 19.6355,
    height: 3.57008,
    rx: 1.39091,
    fill: "#C14F0E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8837_22803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 36,
    width: 21,
    height: 5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5009,
    y: 36.8524,
    width: 19.6355,
    height: 3.57008,
    rx: 1.39091,
    fill: "#C14F0E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8837_22803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.5009,
    y: 36.8524,
    width: 19.6355,
    height: 1.78504,
    fill: "#EE7734"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.286,
    y: 31.4984,
    width: 16.0654,
    height: 2.67756,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.286,
    y: 26.1428,
    width: 16.0654,
    height: 2.67756,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8837_22803)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 27.5,
    width: 16,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#FFDCC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 35L78.5 31L72 35",
    stroke: "#C14F0E",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 41L78.5 37L72 41",
    stroke: "#C14F0E",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 47L78.5 43L72 47",
    stroke: "#C14F0E",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 53L78.5 49L72 53",
    stroke: "#C14F0E",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 59L78.5 55L72 59",
    stroke: "#C14F0E",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 65L78.5 61L72 65",
    stroke: "#C14F0E",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 28,
    width: 15,
    height: 38,
    rx: 3,
    stroke: "#FFDCC1",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8837_22803"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 27,
    width: 17,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.07a9e27647a75f983c79167d6f00dcb4.svg";
export { ForwardRef as ReactComponent };